import {PageTitle} from '@hconnect/uikit/src/lib2'
import {Stack, Box} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../consts'
import {useProductionPlanningHost} from '../providers'

interface PageProductionPlanningHeaderProps {
  plantCode: string
  actions: React.ReactNode
}

export const PageProductionPlanningHeader: React.FC<PageProductionPlanningHeaderProps> = React.memo(
  ({plantCode, actions}) => {
    const {t} = useTranslation(FEATURE_NAMESPACE)
    const {HeaderNotification} = useProductionPlanningHost()
    return (
      <Stack direction="row" spacing={2} justifyContent="space-between" sx={{pr: 3}}>
        <Box component="span" sx={{position: 'relative'}}>
          <PageTitle>{t('navItems.productionPlanning')}</PageTitle>
          {HeaderNotification && <HeaderNotification plantCode={plantCode} />}
        </Box>
        {actions}
      </Stack>
    )
  }
)

PageProductionPlanningHeader.displayName = 'PageProductionPlanningHeader'
